import * as React from "react";
const Basket = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.27246 8.03427V7.06427C8.27246 4.81427 10.0825 2.60427 12.3325 2.39427C15.0125 2.13427 17.2725 4.24427 17.2725 6.87427V8.25427"
      stroke={props.stroke}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.77229 22.3643H15.7723C19.7923 22.3643 20.5123 20.7543 20.7223 18.7943L21.4723 12.7943C21.7423 10.3543 21.0423 8.36426 16.7723 8.36426H8.77229C4.50229 8.36426 3.80229 10.3543 4.07229 12.7943L4.82229 18.7943C5.03229 20.7543 5.75229 22.3643 9.77229 22.3643Z"
      stroke={props.stroke}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2679 12.3643H16.2769"
      stroke={props.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.26709 12.3643H9.27607"
      stroke={props.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Basket;
